jQuery(document).ready(function ($) {

    var combinedMenu = $('#menu').clone();
    var secondMenu = $('#menuTop').clone();
    secondMenu.children('li').appendTo(combinedMenu);

    $(function () {
		combinedMenu.slicknav({
			menuButton: "#menuButton",
			appendTo: "nav",
			allowParentLinks: true,
			nestedParentLinks: false,
			"afterOpen": function (trigger) {
				slicknavOpened(trigger);
			},
		});
	});

	$("button.hamburger").click(function () {
		$("button.hamburger").toggleClass("is-active");
	});

	function slicknavOpened(trigger) {

		var $trigger = $(trigger[0]);
		if ($trigger.hasClass("slicknav_btn")) {
			// this is the top-level menu/list opening.
			// we only want to trap lower-level/sublists.
			return;
		}
		// trigger is an <a> anchor contained in a <li>
		var $liParent = $trigger.parent();
		// parent <li> is contained inside a <ul>
		var $ulParent = $liParent.parent();
		// loop through all children of parent <ul>
		// i.e. all siblings of this <li>
		$ulParent.children().each(function () {
			var $child = $(this);
			if ($child.is($liParent)) {
				// this child is self, not is sibling
				return;
			}
			if ($child.hasClass("slicknav_collapsed")) {
				// this child is already collapsed
				return;
			}
			if (!$child.hasClass("slicknav_open")) {
				// could throw an exception here: this shouldn't happen
				// because I expect li to have class either slicknav_collapsed or slicknav_open
				return;
			}
			// found a sibling <li> which is already open.
			// expect that its first child is an anchor item.
			var $anchor = $child.children().first();
			if (!$anchor.hasClass("slicknav_item")) {
				return;
			}
			// close the sibling by emulating a click on its anchor.
			$anchor.click();
		});
	}

	/* when to transform */

	transformFixedElement("header");
	transformFixedElement(".stick-buttons");

	window.addEventListener("scroll", function () {
		transformFixedElement("header");
		transformFixedElement(".stick-buttons");
	});

	$(".js-filters").on("click", function () {
		$(".row-projects__aside__filter-wrap").toggleClass("is-active");
	});

	checkScrollbarVisibility();

	// Event listener for window resize
	$(window).on("resize", function () {
		checkScrollbarVisibility();
	});

	function checkScrollbarVisibility() {
		const $tableWrapper = $(".table-wrapper");

		if ($tableWrapper.length === 0) {
			return; // Exit if the element doesn't exist
		}

		if ($tableWrapper[0].scrollWidth <= $tableWrapper[0].clientWidth) {
			$tableWrapper.css("overflow-x", "hidden");
			$(".toolbar").hide();
		} else {
			$tableWrapper.css("overflow-x", "scroll");
			$(".toolbar").show();
		}
	}

});

function transformFixedElement(element) {
    var distanceY = window.pageYOffset || document.documentElement.scrollTop,
        transformOn = 150,
        header = $(element),
        configuratorBtn = $('.configurator-button');
    if (distanceY > transformOn) {
        header.addClass("is-active").removeClass("search-active");
        configuratorBtn.removeClass('is-active');
    } else {
        if (header.hasClass("is-active")) {
            header.removeClass("is-active");
        }
        configuratorBtn.addClass('is-active');
    }
}